
import React from 'react';
import { mdx } from '@mdx-js/react';


export const frontMatter = {
	id: 'monitor-api-traffic',
	title: 'Monitor API Traffic'
};
export const contentTitle = undefined;
export const metadata = {
  "unversionedId": "webhooks/monitor-api-traffic",
  "id": "webhooks/monitor-api-traffic",
  "isDocsHomePage": false,
  "title": "Monitor API Traffic",
  "description": "Monitor API Traffic",
  "source": "@site/docs/webhooks/monitor-api-traffic.md",
  "sourceDirName": "webhooks",
  "slug": "/webhooks/monitor-api-traffic",
  "permalink": "/docs/webhooks/monitor-api-traffic",
  "tags": [],
  "version": "current",
  "frontMatter": {
    "id": "monitor-api-traffic",
    "title": "Monitor API Traffic"
  },
  "sidebar": "docs",
  "previous": {
    "title": "Setting up an action",
    "permalink": "/docs/webhooks/setup-an-action"
  },
  "next": {
    "title": "Authentication",
    "permalink": "/docs/api-reference/authentication"
  }
};


/* @jsxRuntime classic */
/* @jsx mdx */

export const toc = [];

const layoutProps = {
  toc
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p><img alt={"Monitor API Traffic"} src={require("!url-loader?limit=10000&name=assets/images/[name]-[hash].[ext]&fallback=file-loader!./monitor-api-traffic.png").default} /></p>
    <p>{`Built-in logging and developer tooling makes it simple to watch traffic to diagnose.`}</p>
    <p><img alt={"Automation Logs"} src={require("!url-loader?limit=10000&name=assets/images/[name]-[hash].[ext]&fallback=file-loader!./automation-logs.png").default} /></p>
    <p>{`Inspect API calls to easily diagnose integrations.`}</p>
    <div {...{
      "className": "admonition admonition-info alert alert--info"
    }}><div parentName="div" {...{
        "className": "admonition-heading"
      }}><h5 parentName="div"><span parentName="h5" {...{
            "className": "admonition-icon"
          }}><svg parentName="span" {...{
              "xmlns": "http://www.w3.org/2000/svg",
              "width": "14",
              "height": "16",
              "viewBox": "0 0 14 16"
            }}><path parentName="svg" {...{
                "fillRule": "evenodd",
                "d": "M7 2.3c3.14 0 5.7 2.56 5.7 5.7s-2.56 5.7-5.7 5.7A5.71 5.71 0 0 1 1.3 8c0-3.14 2.56-5.7 5.7-5.7zM7 1C3.14 1 0 4.14 0 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm1 3H6v5h2V4zm0 6H6v2h2v-2z"
              }}></path></svg></span>{`info`}</h5></div><div parentName="div" {...{
        "className": "admonition-content"
      }}><p parentName="div">{`Webhook calls will be made in JSON, for more information on events and sample bodies, `}<a parentName="p" {...{
            "href": "../api-reference/events-and-actions"
          }}>{`click here`}</a>{`.`}</p></div></div>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
